// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/UnileverShilling.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/UnileverDesire-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/UnileverDesire-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/UnileverDesire-RegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/fonts/UnileverDesire-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../assets/images/CountrySelectMobileIcon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Unilever Shilling";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Semi Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Unilever Desire Regular Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Unilever Desire Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: 300;
  font-style: normal;
}
.LandingHeader_mainHeader__TldZM {
  position: fixed;
  z-index: 9999;
  width: 100%;
  top: 0px;
  left: 0;
  right: 0;
  display: contents;
}

.LandingHeader_mainHeaderSpacer__n43st {
  width: 100%;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_mainHeaderSpacer__n43st {
    height: 60px;
  }
}

.LandingHeader_header__vO4uP {
  width: 100%;
}

.LandingHeader_countryName__to\\+Eu {
  display: flex;
  align-items: center;
  gap: 8px;
}
.LandingHeader_countryName__to\\+Eu .LandingHeader_name__DnQ6D {
  margin: 0;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  text-align: right;
  font-family: "Unilever Desire Regular", sans-serif;
  font-size: 18px;
  font-style: normal;
  line-height: 120%;
  padding-top: 4px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_countryName__to\\+Eu {
    border-right: 0px;
  }
}
.LandingHeader_countryName__to\\+Eu .LandingHeader_countryLogo__z-YKm {
  border-radius: 50%;
}

.LandingHeader_headertop__AiSkM {
  height: 80px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #005AB4;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headertop__AiSkM {
    border-bottom: none;
    height: 0;
  }
}

.LandingHeader_dttReports__c\\+wQx {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  cursor: pointer;
  margin-left: 60px;
}
.LandingHeader_dttReports__c\\+wQx .LandingHeader_backArrow__OPsl8 {
  width: 24px;
  height: 24px;
}
.LandingHeader_dttReports__c\\+wQx p {
  width: 83px;
  font-size: 18px;
  font-weight: 400;
  line-height: 115%;
  margin-bottom: 8px !important;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dttReports__c\\+wQx {
    display: none;
  }
}

.LandingHeader_navlinks__Ojrcm, .LandingHeader_menuSide__pMvr\\+ {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #FFFFFF;
  margin-right: 48px;
  gap: 20px;
  cursor: pointer;
}
.LandingHeader_navlinks__Ojrcm .LandingHeader_separator__Zf91h, .LandingHeader_menuSide__pMvr\\+ .LandingHeader_separator__Zf91h {
  width: 1px;
  height: 37px;
  background-color: #5588F7;
  display: flex;
  align-self: center;
  flex-shrink: 0;
}
.LandingHeader_navlinks__Ojrcm p, .LandingHeader_menuSide__pMvr\\+ p {
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 0px;
}
.LandingHeader_navlinks__Ojrcm span, .LandingHeader_menuSide__pMvr\\+ span {
  display: none;
  gap: 8px;
  align-items: center;
  cursor: pointer;
}
.LandingHeader_navlinks__Ojrcm span p, .LandingHeader_menuSide__pMvr\\+ span p {
  font-weight: 400;
  font-size: 14px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_navlinks__Ojrcm, .LandingHeader_menuSide__pMvr\\+ {
    position: absolute;
    left: -200%;
  }
}

.LandingHeader_profileIcon__40li3 {
  padding-left: 20px;
  border-left: 1px solid #5588F7;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_profileIcon__40li3 {
    display: none !important;
    border-left: 0;
    padding-left: 0;
  }
}
.LandingHeader_profileIcon__40li3 img {
  width: 37px;
  height: 37px;
}

:root {
  --rt-opacity: 1 !important;
}

.LandingHeader_popupModal__Da4gL {
  background: #FFFFFF !important;
  border-radius: 8px;
  padding: 0 !important;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  z-index: 1;
  color: #000000;
  overflow: hidden;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C {
  width: 344px;
  display: flex;
  flex-direction: column;
  gap: 0;
  cursor: auto !important;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupDetails__DE8ju {
  padding: 16px;
  width: 100%;
  border-radius: 0;
  background: #C2E0FF;
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupDetails__DE8ju .LandingHeader_popupProfileIcon__P1huv {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #FFFFFF;
  padding: 12px;
  box-sizing: border-box;
  object-fit: contain;
  object-position: center;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupDetails__DE8ju .LandingHeader_profileText__9TF1Z {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupDetails__DE8ju h4 {
  font-family: "Unilever Desire Bold", sans-serif;
  font-size: 16px;
  margin: 0;
  color: #000000;
  line-height: 120%;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupDetails__DE8ju p {
  font-family: "Unilever Desire Regular", sans-serif;
  font-size: 14px;
  margin: 0;
  color: #000000;
  line-height: 120%;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_dtAccess__Iqlx8 {
  display: grid;
  grid-template-columns: 1fr auto;
  row-gap: 4px;
  column-gap: 8px;
  width: 100%;
  padding: 24px 16px 0;
  color: #000000;
  align-items: start;
  border-radius: 0;
  background: #FFFFFF;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_dtAccess__Iqlx8 p {
  margin: 0;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_dtAccess__Iqlx8 .LandingHeader_title__ANkLM {
  font-family: "Unilever Desire Semi Bold", sans-serif;
  font-size: 16px;
  color: #000000;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_dtAccess__Iqlx8 .LandingHeader_display__ZmToR {
  font-family: "Unilever Desire Regular", sans-serif;
  font-size: 14px;
  margin-left: 0;
  grid-column: 1/-1;
  color: #000000;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_dtAccess__Iqlx8 .LandingHeader_toggle__evyER {
  display: flex;
  align-items: end;
  color: #000000;
  cursor: pointer;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupLogout__MKqR4 {
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 16px;
  margin: 0;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0;
  background: transparent;
  justify-content: flex-start;
  align-items: center;
  transition: opacity 0.2s ease;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupLogout__MKqR4:hover {
  opacity: 0.8;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupLogout__MKqR4 img {
  display: none;
}
.LandingHeader_popupModal__Da4gL .LandingHeader_popup__s7p\\+C .LandingHeader_popupLogout__MKqR4 p {
  color: #0066CC;
  font-family: "Unilever Desire Semi Bold", sans-serif;
  font-size: 16px;
  margin: 0;
  padding: 0;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_popupModal__Da4gL {
    display: none;
  }
}

.LandingHeader_sideMenuOptions__oz4T8 {
  min-height: 64px;
  display: none;
}
.LandingHeader_sideMenuOptions__oz4T8 img {
  width: 24px;
  height: 24px;
  color: #FFFFFF;
}
.LandingHeader_sideMenuOptions__oz4T8 p {
  color: #FFFFFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.LandingHeader_closebtn__-LIU7 {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 18px;
  top: 40px;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_menuSide__pMvr\\+ {
    position: absolute;
    left: 0;
    bottom: 0px;
    height: 100%;
    width: 100%;
    background-color: #FFFFFF;
    color: #000000;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 999;
  }
}

.LandingHeader_headerbottom__Ci5x2, .LandingHeader_headerSidebar__N2hsW {
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(328deg, #006FDE 48.33%, #06C 101.85%);
}
.LandingHeader_headerbottom__Ci5x2 p, .LandingHeader_headerSidebar__N2hsW p {
  margin-bottom: 0px !important;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headerbottom__Ci5x2, .LandingHeader_headerSidebar__N2hsW {
    height: 60px;
  }
  .LandingHeader_headerbottom__Ci5x2 p, .LandingHeader_headerSidebar__N2hsW p {
    margin-right: 16px;
    font-size: 16px;
    margin-bottom: 0 !important;
  }
}

.LandingHeader_hideHeaderBottom__FWKrB {
  display: none;
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headerSidebar__N2hsW {
    position: fixed;
    background-color: #275CE6;
    display: flex;
    flex-direction: column;
    height: 250px;
    width: 100%;
    justify-content: space-around;
    z-index: 999;
  }
  .LandingHeader_headerSidebar__N2hsW div,
  .LandingHeader_headerSidebar__N2hsW p {
    width: 100%;
    display: flex;
  }
  .LandingHeader_headerSidebar__N2hsW p {
    font-size: 16px;
    bottom: 60px;
    left: 16px;
    width: auto;
  }
  .LandingHeader_headerSidebar__N2hsW .LandingHeader_countryNameMbl__aVA-\\+ {
    display: none;
  }
}

.LandingHeader_menuIcons__9219c {
  display: none;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_menuIcons__9219c {
    display: block;
  }
}

@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_menuSide__pMvr\\+ {
    border-radius: 24px 24px 0px 0px;
    padding-top: 32px;
    position: fixed;
    height: calc(100vh - 200px);
    padding-left: 16px;
    overflow: hidden;
    scrollbar-width: none;
    background: #082D54;
    z-index: 2000;
  }
  .LandingHeader_menuSide__pMvr\\+ div,
  .LandingHeader_menuSide__pMvr\\+ span {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    text-align: center;
    width: 100%;
  }
}

.LandingHeader_headerbottom__Ci5x2 .LandingHeader_backButton__gNFPL p, .LandingHeader_headerSidebar__N2hsW .LandingHeader_backButton__gNFPL p {
  font-size: 16px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_headerbottom__Ci5x2 .LandingHeader_backButton__gNFPL, .LandingHeader_headerSidebar__N2hsW .LandingHeader_backButton__gNFPL {
    display: none;
  }
}

.LandingHeader_dropdownConatiner__e1IUB {
  display: flex;
  gap: 16px;
  height: 100%;
  padding: 0px 8px 0px 0px;
  align-items: center;
  margin-left: 60px;
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_backButton__gNFPL {
  margin-left: 24px;
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdownWrapper__FMqxa {
  display: flex;
  height: 100%;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dropdownConatiner__e1IUB {
    flex-direction: column !important;
    display: none;
  }
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdownselected__2DCJP {
  background: #5588F7;
  border-bottom: 3px solid #FFFFFF;
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdownselected__2DCJP span {
  font-weight: 600;
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdown__\\+LP1J {
  position: relative;
  height: 100%;
  align-items: center;
  display: flex;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdown__\\+LP1J {
    flex-direction: column !important;
  }
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdown__\\+LP1J span {
  color: #FFFFFF;
  font-size: 14px;
  padding: 0px 8px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdown__\\+LP1J span {
    color: #000000;
  }
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdown__\\+LP1J .LandingHeader_dropdownBody__lTzKl {
  scrollbar-width: none;
  position: absolute;
  z-index: 1;
  background: #275CE6;
  padding: 1rem 0px;
  display: flex;
  width: 322px;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  top: 90%;
  z-index: 9999;
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdown__\\+LP1J .LandingHeader_dropdownBody__lTzKl .LandingHeader_dropdownOptions__-1IG4:hover {
  background-color: #5588F7;
  font-weight: 600;
}
.LandingHeader_dropdownConatiner__e1IUB .LandingHeader_dropdown__\\+LP1J .LandingHeader_dropdownBody__lTzKl .LandingHeader_dropdownOptions__-1IG4 {
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  width: 100%;
  padding: 8px 1rem;
}

.LandingHeader_SMOMobileView__JVXod {
  min-height: 64px;
}
.LandingHeader_SMOMobileView__JVXod p {
  color: #FFFFFF;
}

.LandingHeader_dropdownMobile__HZcXX {
  flex-direction: column !important;
  gap: 0px !important;
  height: max-content;
  justify-content: flex-start;
  font-size: 14px !important;
  align-items: flex-start !important;
  width: 100%;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownHeading__22sG3 {
  margin-left: 0px;
  min-height: 64px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownHeading__22sG3 .LandingHeader_dropdownHeadingName__A\\+o\\+4 {
  flex-basis: 75%;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownHeading__22sG3 .LandingHeader_dropdownHeadingArrow__rpRTY {
  flex-basis: 25%;
  justify-content: center;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownArrowOpen__TsJiP {
  transform: rotate(-90deg);
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownArrowClose__JnMst {
  transform: rotate(90deg);
}
.LandingHeader_dropdownMobile__HZcXX span {
  width: 100%;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownBody__lTzKl {
  flex-direction: column !important;
  gap: 0px !important;
  overflow: hidden;
  width: calc(100% + 16px);
  margin-left: -16px !important;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownBody__lTzKl .LandingHeader_dropdownOptions__-1IG4 {
  margin: 0px !important;
  width: 100%;
  padding-left: calc(2.5rem + 16px);
  min-height: 48px;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownBody__lTzKl .LandingHeader_dropdownOptions__-1IG4 div {
  min-height: 48px;
}
.LandingHeader_dropdownMobile__HZcXX .LandingHeader_dropdownBody__lTzKl .LandingHeader_dropdownSelected__8lco7 {
  background: #F3F7FD;
}

.LandingHeader_navLinkSelected__Rb698 {
  height: 100%;
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  background-color: #5588F7 !important;
  position: relative;
}

.LandingHeader_navLinkSelected__Rb698::after {
  content: "";
  border: 3px solid #F3F7FD;
  position: absolute;
  bottom: -2px;
  width: 102%;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);
}

.LandingHeader_adminDropdown__novhE {
  position: relative;
}
.LandingHeader_adminDropdown__novhE img:last-child {
  position: absolute;
  right: 16px;
  transform: rotate(90deg);
  transition: transform 0.1s ease-in-out;
}
.LandingHeader_adminDropdown__novhE .LandingHeader_invertArrow__Vl77p {
  transform: rotate(-90deg) !important;
}

.LandingHeader_adminDropdownOptions__lu60z {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: flex-start !important;
  padding-left: 38px;
}
.LandingHeader_adminDropdownOptions__lu60z p {
  height: 40px;
  display: flex;
  align-items: center;
}

.LandingHeader_dropdownCountry__6R8oG {
  width: auto;
  flex-shrink: 0;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dropdownCountry__6R8oG {
    width: auto;
  }
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px {
  height: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;
  padding: 0px;
  background: transparent;
  border: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px {
    gap: 8px;
  }
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px:focus, .LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px:focus-visible, .LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px:focus-within {
  border: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px:hover {
  border: none;
  box-shadow: none;
  outline: none;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_countryName__to\\+Eu {
  border-right: 0;
  color: red;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_countryName__to\\+Eu .LandingHeader_nameOption__r5kmz {
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 5px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_countryName__to\\+Eu {
    padding-right: 6px;
  }
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownArrow__yQGyO {
  display: flex;
  align-items: center;
  margin-left: 4px;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownArrow__yQGyO div {
  padding: 0;
  display: flex;
  align-items: center;
  color: #FFFFFF;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownArrow__yQGyO svg {
  padding: 0 !important;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownArrowsm__c38De {
  padding: 0 !important;
  margin: 0 !important;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownArrowsm__c38De div {
  padding: 0 !important;
  margin: 0 !important;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownArrowsm__c38De svg {
  display: none;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownArrowsm__c38De::after {
  content: "";
  display: block;
  width: 8px;
  height: 6px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: 0;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownControl__rn5px .LandingHeader_dropdownText__gj-mB {
  width: max-content;
  font-size: 90%;
  font-weight: 400;
  color: #FFFFFF;
  font-family: "Unilever Desire", sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue" !important;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_seperator__7ES4p {
  display: none;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownArrow__yQGyO {
  display: flex;
  align-items: center;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownArrow__yQGyO div {
  display: flex;
  align-items: center;
  padding: 0;
  color: #FFFFFF;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_dropdownArrow__yQGyO svg {
  display: block;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menu__tdNHP {
  width: 219px;
  height: 229px;
  overflow: hidden;
  background: #FFFFFF;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .LandingHeader_dropdownCountry__6R8oG .LandingHeader_menu__tdNHP {
    position: absolute;
    right: 15%;
  }
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menuList__OlmUw {
  padding: 0;
  border-radius: 9px 8px 0 0;
  background: #FFFFFF;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menuOption__1bsrG {
  min-width: 100%;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
  border-bottom: none;
  background: #FFFFFF;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menuOption__1bsrG:first-child {
  background: #C2E0FF;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menuOption__1bsrG .LandingHeader_countryName__to\\+Eu {
  border-right: 0;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menuOption__1bsrG .LandingHeader_countryName__to\\+Eu .LandingHeader_nameOption__r5kmz {
  font-size: 16px;
  font-weight: 200;
  color: #000000;
  padding-bottom: 15px;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menuOption__1bsrG:hover {
  background: #C2E0FF;
}
.LandingHeader_dropdownCountry__6R8oG .LandingHeader_menuOption__1bsrG .LandingHeader_selected__gasba {
  background: #C2E0FF;
}

.LandingHeader_flexibleRow__m-9Z3 {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
}
.LandingHeader_flexibleRow__m-9Z3 .LandingHeader_separator__Zf91h {
  width: 1px;
  height: 37px;
  background-color: #5588F7;
  margin: 0 8px;
  display: flex;
  align-self: center;
}

.LandingHeader_mobileCenterLogo__d2DFP {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 143px;
  height: 49px;
  cursor: pointer;
}

.LandingHeader_flexibleCol__47UpL {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 16px 16px 32px 16px;
  border-radius: 8px;
  background: linear-gradient(328deg, rgba(25, 50, 104, 0.2) 48.33%, #0066CC 101.85%);
  color: #FFFFFF;
}
.LandingHeader_flexibleCol__47UpL h4 {
  padding: 24px 0 15px;
  margin: 0;
  font-family: "Unilever Desire", sans-serif;
  font-weight: 900;
  font-style: normal;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0%;
}
.LandingHeader_flexibleCol__47UpL > p {
  margin: 0 0 15px 0 !important;
  font-family: "Unilever Desire", sans-serif;
  font-style: normal;
  font-size: 12px;
  line-height: 120%;
  color: #FFFFFF;
}
.LandingHeader_flexibleCol__47UpL > p:nth-of-type(1) {
  font-weight: 400;
}
.LandingHeader_flexibleCol__47UpL > p:nth-of-type(2) {
  font-weight: 600;
}
.LandingHeader_flexibleCol__47UpL .LandingHeader_bsaRow__y2P0H {
  margin-top: 0;
}

.LandingHeader_bsaRow__y2P0H {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  width: 100%;
  flex-wrap: nowrap;
}
.LandingHeader_bsaRow__y2P0H span {
  white-space: nowrap;
  font-family: "Unilever Desire", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  color: #FFFFFF;
}

.LandingHeader_bsaSelectContainer__ohUa7 {
  width: auto;
  min-width: 110px;
  display: inline-block;
}

.LandingHeader_bsaSelectControl__go3CE {
  min-height: 20px !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0 !important;
  cursor: pointer;
  flex-wrap: nowrap !important;
}

.LandingHeader_bsaSelectValue__XDAFB {
  padding: 0 !important;
  overflow: visible !important;
  flex-wrap: nowrap !important;
}

.LandingHeader_bsaSelectText__1l6Er {
  position: static !important;
  transform: none !important;
  max-width: none !important;
  font-family: "Unilever Desire", sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 120% !important;
  color: #FFFFFF !important;
  margin: 0 !important;
  white-space: nowrap !important;
  overflow: visible !important;
}

.LandingHeader_bsaSelectInput__edCzJ {
  color: transparent !important;
  caret-color: transparent !important;
  margin: 0 !important;
  padding: 0 !important;
  width: 0 !important;
}
.LandingHeader_bsaSelectInput__edCzJ input {
  caret-color: transparent !important;
  color: transparent !important;
  width: 0 !important;
  opacity: 0 !important;
}

.LandingHeader_bsaSelectIndicators__jnYZP {
  padding: 0 !important;
  align-items: center !important;
}

.LandingHeader_bsaSelectArrow__su8rL {
  padding: 0 0 0 4px !important;
  color: #FFFFFF !important;
}
.LandingHeader_bsaSelectArrow__su8rL svg {
  width: 14px;
  height: 14px;
  fill: #FFFFFF;
}
.LandingHeader_bsaSelectArrow__su8rL:hover {
  color: #FFFFFF !important;
}

.LandingHeader_bsaSelectMenu__Yaw9J {
  width: 113px !important;
  background: #082D54 !important;
  border: 1px solid #2381DE !important;
  border-radius: 4px !important;
  margin: 4px 0 0 0 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
  overflow: hidden;
}

.LandingHeader_bsaSelectMenuList__L8B3d {
  padding: 0 !important;
  background: #082D54 !important;
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
}

.LandingHeader_bsaSelectOption__KMwzx {
  display: block !important;
  width: 100% !important;
  box-sizing: border-box !important;
  font-family: "Unilever Desire", sans-serif !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  line-height: 120% !important;
  color: #FFFFFF !important;
  background: #082D54 !important;
  padding: 8px 10px !important;
  cursor: pointer !important;
}
.LandingHeader_bsaSelectOption__KMwzx:hover, .LandingHeader_bsaSelectOption__KMwzx:active {
  background: #054179 !important;
}
.LandingHeader_bsaSelectOption__KMwzx[aria-selected=true] {
  background: #054179 !important;
  font-weight: 600 !important;
}

.LandingHeader_adminConfigSpan__CPbCO {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  margin-left: 20px;
  cursor: pointer;
}

.LandingHeader_adminBreadcrumb__Rj-KE {
  display: flex;
  align-items: center;
  gap: 10px;
}

.LandingHeader_adminBreadcrumbSeparator__QlgUv,
.LandingHeader_adminBreadcrumbCurrent__rStY0 {
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
}

.LandingHeader_adminBreadcrumbSeparator__QlgUv {
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_mixin.scss","webpack://./src/components_upgrade/LandingHomePage/LandingHeader/LandingHeader.module.scss","webpack://./src/assets/styles/_variables.scss","webpack://./src/assets/styles/tokens/_spacing.scss","webpack://./src/assets/styles/tokens/_colors.scss","webpack://./src/assets/styles/tokens/_typography.scss","webpack://./src/assets/styles/tokens/_radius.scss","webpack://./src/assets/styles/tokens/_sizing.scss"],"names":[],"mappings":"AAIA;EACE,gCAAA;EACA,+DAAA;EACA,mBAAA;EACA,kBAAA;ACHF;ADMA;EACE,sCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACJF;ADQA;EACE,wCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACNF;ADUA;EACE,mCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACRF;ADWA;EACE,6CAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACTF;ADYA;EACE,oCAAA;EACA,2DAAA;EACA,gBAAA;EACA,kBAAA;ACVF;AA/BA;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,QCwDa;EDvDb,OAAA;EACA,QAAA;EACA,iBAAA;AAiCF;;AA9BA;EACE,WAAA;AAiCF;ADeE;ECjDF;IAII,YEWU;EFuBZ;AACF;;AA/BA;EACE,WAAA;AAkCF;;AA/BA;EACE,aAAA;EACA,mBAAA;EACA,QEZa;AF8Cf;AAhCE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,cG7BU;EH8BV,iBAAA;EACA,kDIpCyB;EJqCzB,eCIiB;EDHjB,kBAAA;EACA,iBAAA;EACA,gBEzBU;AF2Dd;ADZE;ECrCF;IAmBI,iBCmBW;EDeb;AACF;AAhCE;EACE,kBKxCY;AL0EhB;;AA9BA;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBGlCwB;EHmCxB,kDAAA;AAiCF;AD/BE;ECVF;IAWI,mBAAA;IACA,SAAA;EAkCF;AACF;;AA/BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cGnEY;EHoEZ,eAAA;EACA,iBE9CY;AFgFd;AAhCE;EACE,WAAA;EACA,YAAA;AAkCJ;AA/BE;EACE,WAAA;EACA,eC1CiB;ED2CjB,gBClCiB;EDmCjB,iBAAA;EACA,6BAAA;AAiCJ;ADzDE;ECMF;IAsBI,aAAA;EAiCF;AACF;;AA9BA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cG7FY;EH8FZ,kBE1Ec;EF2Ed,SEnFW;EFoFX,eAAA;AAiCF;AA/BE;EACE,UAAA;EACA,YM1FW;EN2FX,yBG/EmB;EHgFnB,aAAA;EACA,kBAAA;EACA,cAAA;AAiCJ;AA9BE;EACE,eC1EgB;ED2EhB,gBChEiB;EDiEjB,kBCpDW;ADoFf;AA7BE;EACE,aAAA;EACA,QExGW;EFyGX,mBAAA;EACA,eAAA;AA+BJ;AA7BI;EACE,gBC3Ee;ED4Ef,eCvFc;ADsHpB;AD/FE;ECgCF;IAqCI,kBAAA;IACA,WAAA;EA8BF;AACF;;AA3BA;EACE,kBExHW;EFyHX,8BAAA;AA8BF;AD1GE;EC0EF;IAKI,wBAAA;IACA,cAAA;IACA,eAAA;EA+BF;AACF;AA7BE;EACE,WMpIW;ENqIX,YMrIW;ANoKf;;AA3BA;EACE,0BAAA;AA8BF;;AA3BA;EACE,8BAAA;EACA,kBK5JU;EL6JV,qBAAA;EACA,2CAAA;EACA,UAAA;EACA,cG5JY;EH6JZ,gBAAA;AA8BF;AA5BE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,uBAAA;AA8BJ;AA5BI;EACE,aC1GO;ED2GP,WAAA;EACA,gBAAA;EACA,mBG1HgB;EH2HhB,aAAA;EACA,mBAAA;EACA,SChHO;EDiHP,mBAAA;AA8BN;AA5BM;EACE,cAAA;EACA,WEhKM;EFiKN,YEjKM;EFkKN,kBKlLQ;ELmLR,yBGtLM;EHuLN,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA8BR;AA3BM;EACE,aAAA;EACA,sBAAA;EACA,QEtLM;EFuLN,SAAA;AA6BR;AA1BM;EACE,+CIxMkB;EJyMlB,eCnKc;EDoKd,SAAA;EACA,cGvMM;EHwMN,iBAAA;AA4BR;AAzBM;EACE,kDIlNqB;EJmNrB,eC5KY;ED6KZ,SAAA;EACA,cG/MM;EHgNN,iBAAA;AA2BR;AAvBI;EACE,aAAA;EACA,+BAAA;EACA,YE9MQ;EF+MR,eE9MS;EF+MT,WAAA;EACA,oBAAA;EACA,cG3NQ;EH4NR,kBAAA;EACA,gBAAA;EACA,mBG/NQ;AHwPd;AAvBM;EACE,SAAA;AAyBR;AAtBM;EACE,oDI1OsB;EJ2OtB,eCpMc;EDqMd,cGvOM;AH+Pd;AArBM;EACE,kDIjPqB;EJkPrB,eC3MY;ED4MZ,cAAA;EACA,iBAAA;EACA,cG/OM;AHsQd;AApBM;EACE,aAAA;EACA,gBAAA;EACA,cGrPM;EHsPN,eAAA;AAsBR;AAlBI;EACE,aAAA;EACA,mBAAA;EACA,QEnPS;EFoPT,aAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;AAoBN;AAlBM;EACE,YAAA;AAoBR;AAjBM;EACE,aAAA;AAmBR;AAhBM;EACE,cG9NY;EH+NZ,oDIvRsB;EJwRtB,eCjPc;EDkPd,SAAA;EACA,UAAA;AAkBR;AD/OE;EC8FF;IAqII,aAAA;EAgBF;AACF;;AAbA;EACE,gBAAA;EACA,aAAA;AAgBF;AAdE;EACE,WAAA;EACA,YAAA;EACA,cGvSU;AHuTd;AAbE;EACE,cG3SU;EH4SV,eC1QgB;ED2QhB,kBAAA;EACA,gBCjQiB;EDkQjB,iBCxPiB;ADuQrB;;AAVA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WCzPa;ED0Pb,SEtSY;AFmTd;;AD7QE;ECmQF;IAII,kBAAA;IACA,OAAA;IACA,WCxQW;IDyQX,YAAA;IACA,WAAA;IACA,yBGrUU;IHsUV,cGrUU;IHsUV,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,YAAA;EAWF;AACF;;AARA;EACE,WAAA;EACA,YE1TY;EF2TZ,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iEAAA;AAWF;AATE;EACE,6BAAA;EACA,gBC3SiB;ED4SjB,eCvTgB;EDwThB,cG1VU;AHqWd;AD5SE;ECqRF;IAgBI,YEvUU;EFkVZ;EATE;IACE,kBCnSO;IDoSP,eC/TgB;IDgUhB,2BAAA;EAWJ;AACF;;AAPA;EACE,aAAA;AAUF;;AD1TE;ECmTF;IAII,eAAA;IACA,yBG5ViB;IH6VjB,aAAA;IACA,sBAAA;IACA,aAAA;IACA,WAAA;IACA,6BAAA;IACA,YAAA;EAQF;EANE;;IAEE,WAAA;IACA,aAAA;EAQJ;EALE;IACE,eC7VgB;ID8VhB,YE1WQ;IF2WR,UCpUO;IDqUP,WAAA;EAOJ;EAJE;IACE,aAAA;EAMJ;AACF;;AAFA;EACE,aAAA;AAKF;ADzVE;ECmVF;IAII,cAAA;EAMF;AACF;;AD9VE;EC2VF;IAEI,gCAAA;IACA,iBEtYU;IFuYV,eAAA;IACA,2BAAA;IACA,kBC5VS;ID6VT,gBAAA;IACA,qBAAA;IACA,mBGnYY;IHoYZ,aAAA;EAMF;EAJE;;IAEE,aAAA;IACA,mBAAA;IACA,SCtWO;IDuWP,mBAAA;IACA,kBAAA;IACA,WAAA;EAMJ;AACF;;AAAI;EACE,eC5YgB;AD+YtB;ADzXE;ECoXA;IAMI,aAAA;EAGJ;AACF;;AACA;EACE,aAAA;EACA,SC5XW;ED6XX,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,iBEvaY;AFyad;AAAE;EACE,iBAAA;AAEJ;AACE;EACE,aAAA;EACA,YAAA;AACJ;AD9YE;EC+XF;IAkBI,iCAAA;IACA,aAAA;EACF;AACF;AACE;EACE,mBGzbmB;EH0bnB,gCAAA;AACJ;AACI;EACE,gBCpaiB;ADqavB;AAGE;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AADJ;ADjaE;EC8ZA;IAOI,iCAAA;EAAJ;AACF;AAEI;EACE,cGleQ;EHmeR,eCjcc;EDkcd,gBAAA;AAAN;AD3aE;ECwaE;IAMI,cGteM;EHueZ;AACF;AAEI;EACE,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBG1de;EH2df,iBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,2CAAA;EACA,QAAA;EACA,aAAA;AAAN;AAIM;EACE,yBGtee;EHuef,gBC9ce;AD4cvB;AAKM;EACE,eC/dY;EDgeZ,gBCrda;EDsdb,cGngBM;EHogBN,WAAA;EACA,iBAAA;AAHR;;AASA;EACE,gBAAA;AANF;AAQE;EACE,cG/gBU;AHygBd;;AAWA;EACE,iCAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;EACA,kCAAA;EACA,WAAA;AARF;AAUE;EACE,gBCpeW;EDqeX,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AARJ;AAUI;EACE,eAAA;AARN;AAWI;EACE,eAAA;EACA,uBAAA;AATN;AAaE;EACE,yBAAA;AAXJ;AAcE;EACE,wBAAA;AAZJ;AAeE;EACE,WAAA;AAbJ;AAgBE;EACE,iCAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;AAdJ;AAgBI;EACE,sBAAA;EACA,WAAA;EACA,iCAAA;EACA,gBAAA;AAdN;AAgBM;EACE,gBAAA;AAdR;AAkBI;EACE,mBG/iBW;AH+hBjB;;AAqBA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBC1iBqB;ED2iBrB,oCAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,8CAAA;AAlBF;;AAqBA;EACE,kBAAA;AAlBF;AAoBE;EACE,kBAAA;EACA,WC9iBS;ED+iBT,wBAAA;EACA,sCAAA;AAlBJ;AAqBE;EACE,oCAAA;AAnBJ;;AAuBA;EACE,aAAA;EACA,iCAAA;EACA,uBAAA;EACA,kCAAA;EACA,kBAAA;AApBF;AAsBE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AApBJ;;AAwBA;EACE,WAAA;EACA,cAAA;AArBF;ADxjBE;EC2kBF;IAKI,WAAA;EApBF;AACF;AAsBE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,YCvlBW;EDwlBX,uBAAA;EACA,uBAAA;EACA,oCAAA;EACA,2BAAA;EACA,wBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;AApBJ;AD3kBE;ECmlBA;IAeI,QAAA;EAnBJ;AACF;AAqBI;EAGE,uBAAA;EACA,oCAAA;EACA,2BAAA;EACA,wBAAA;AArBN;AAwBI;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AAtBN;AAyBI;EACE,eAAA;EACA,UAAA;AAvBN;AAyBM;EACE,eC7oBiB;ED8oBjB,gBCtoBa;EDuoBb,kBAAA;AAvBR;ADpmBE;EConBE;IAWI,kBAAA;EAvBN;AACF;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAxBN;AA0BM;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,cGrsBM;AH6qBd;AA2BM;EACE,qBAAA;AAzBR;AA6BI;EACE,qBAAA;EACA,oBAAA;AA3BN;AA6BM;EACE,qBAAA;EACA,oBAAA;AA3BR;AA8BM;EACE,aAAA;AA5BR;AA+BM;EACE,WAAA;EACA,cAAA;EACA,UEltBO;EFmtBP,WAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,SAAA;AA7BR;AAiCI;EACE,kBAAA;EACA,cAAA;EACA,gBC7rBe;ED8rBf,cG3uBQ;EH4uBR,4LAAA;AA/BN;AAqCE;EACE,aAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,mBAAA;AApCJ;AAsCI;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cG9vBQ;AH0tBd;AAuCI;EACE,cAAA;AArCN;AAyCE;EACE,YM1vB0B;EN2vB1B,aM1vB2B;EN2vB3B,gBAAA;EACA,mBG1wBU;AHmuBd;AD1qBE;EC6sBA;IAOI,kBAAA;IACA,UAAA;EAtCJ;AACF;AAyCE;EACE,UAAA;EACA,0BKtxBsB;ELuxBtB,mBGrxBU;AH8uBd;AA0CE;EACE,eAAA;EACA,uBAAA;EAAA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBG7xBU;AHqvBd;AA0CI;EACE,mBG/uBgB;AHusBtB;AA2CI;EACE,eAAA;AAzCN;AA2CM;EACE,eCpwBc;EDqwBd,gBIlxBY;EJmxBZ,cGxyBM;EHyyBN,oBEtyBO;AF6vBf;AA6CI;EACE,mBG9vBgB;AHmtBtB;AA8CI;EACE,mBGlwBgB;AHstBtB;;AAiDA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBCjwBW;ADmtBb;AAgDE;EACE,UAAA;EACA,YMzzBW;EN0zBX,yBG9yBmB;EH+yBnB,aAAA;EACA,aAAA;EACA,kBAAA;AA9CJ;;AAkDA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AA/CF;;AAkDA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,kBK71BU;EL81BV,mFAAA;EACA,cG51BY;AH6yBd;AAiDE;EACE,oBAAA;EACA,SAAA;EACA,0CIv2Be;EJw2Bf,gBIv0BgB;EJw0BhB,kBAAA;EACA,eCj0BkB;EDk0BlB,iBAAA;EACA,kBAAA;AA/CJ;AAkDE;EACE,6BAAA;EACA,0CIj3Be;EJk3Bf,kBAAA;EACA,eC50BiB;ED60BjB,iBAAA;EACA,cG/2BU;AH+zBd;AAmDE;EACE,gBCt0BiB;ADqxBrB;AAoDE;EACE,gBCx0BmB;ADsxBvB;AAqDE;EACE,aAAA;AAnDJ;;AAuDA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QEz3Ba;EF03Bb,WAAA;EACA,iBAAA;AApDF;AAsDE;EACE,mBAAA;EACA,0CIh5Be;EJi5Bf,kBAAA;EACA,gBC71BmB;ED81BnB,eC52BiB;ED62BjB,iBAAA;EACA,cG/4BU;AH21Bd;;AAwDA;EACE,WAAA;EACA,gBAAA;EACA,qBAAA;AArDF;;AAwDA;EACE,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;AArDF;;AAwDA;EACE,qBAAA;EACA,4BAAA;EACA,4BAAA;AArDF;;AAwDA;EACE,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,qDAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,oBAAA;EACA,8BAAA;EACA,4BAAA;AArDF;;AAwDA;EACE,6BAAA;EACA,mCAAA;EACA,oBAAA;EACA,qBAAA;EACA,mBAAA;AArDF;AAuDE;EACE,mCAAA;EACA,6BAAA;EACA,mBAAA;EACA,qBAAA;AArDJ;;AAyDA;EACE,qBAAA;EACA,8BAAA;AAtDF;;AAyDA;EACE,6BAAA;EACA,yBAAA;AAtDF;AAwDE;EACE,WCp5BW;EDq5BX,YCr5BW;EDs5BX,aGn9BU;AH65Bd;AAyDE;EACE,yBAAA;AAvDJ;;AA2DA;EACE,uBAAA;EACA,8BAAA;EACA,oCAAA;EACA,6BAAA;EACA,4BAAA;EACA,qDAAA;EACA,gBAAA;AAxDF;;AA2DA;EACE,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,iCAAA;EACA,sBAAA;AAxDF;;AA2DA;EACE,yBAAA;EACA,sBAAA;EACA,iCAAA;EACA,qDAAA;EACA,6BAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,0BAAA;AAxDF;AA0DE;EAEE,8BAAA;AAzDJ;AA4DE;EACE,8BAAA;EACA,2BAAA;AA1DJ;;AA8DA;EACE,cGvgCY;EHwgCZ,eCt+BkB;EDu+BlB,gBC39BmB;ED49BnB,iBE9/BW;EF+/BX,eAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,mBAAA;EACA,SCt9BW;AD25Bb;;AA8DA;;EAEE,cGthCY;EHuhCZ,eCr/BkB;EDs/BlB,gBC1+BmB;AD+6BrB;;AA8DA;EACE,YAAA;AA3DF","sourcesContent":["@import \"./variables\";\n\n// Font family\n\n@font-face {\n  font-family: \"Unilever Shilling\";\n  src: url(\"../fonts/UnileverShilling.ttf\")format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular\";\n  src: url(\"../fonts/UnileverDesire-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Semi Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n\n@font-face {\n  font-family: \"Unilever Desire Bold\";\n  src: url(\"../fonts/UnileverDesire-Bold.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Regular Italic\";\n  src: url(\"../fonts/UnileverDesire-RegularItalic.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: italic;\n}\n\n@font-face {\n  font-family: \"Unilever Desire Light\";\n  src: url(\"../fonts/UnileverDesire-Light.woff\") format(\"woff\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n\n\n\n\n// Font families and font-weights\n\n@mixin volteMedium {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin volteSemibold {\n  font-family: \"Unilever Shilling\", sans-serif;\n}\n\n@mixin sm {\n  @media only screen and (min-width: 320px) and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media only screen and (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm-min {\n  @media only screen and (min-width: 992px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media only screen and (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl-min {\n  @media only screen and (min-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media only screen and (min-width: 1280px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media only screen and (min-width: 1440px) {\n    @content;\n  }\n}\n\n@mixin sm-tab {\n  @media only screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n@mixin ipad {\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    @content;\n  }\n}\n\n","@import \"../../../assets/styles/abstracts/variables\";\n@import \"../../../assets/styles/abstracts/mixins\";\n@import \"../../../assets/styles/tokens/colors\";\n\n.mainHeader {\n  position: fixed;\n  z-index: 9999;\n  width: 100%;\n  top: $spacing-zero;\n  left: 0;\n  right: 0;\n  display: contents;\n}\n\n.mainHeaderSpacer {\n  width: 100%;\n\n  @include sm {\n    height: $spacing-6xl;\n  }\n}\n\n.header {\n  width: 100%;\n}\n\n.countryName {\n  display: flex;\n  align-items: center;\n  gap: $spacing-sm-s;\n\n  .name {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    color: $color-white;\n    text-align: right;\n    font-family: $font-family-desire-regular;\n    font-size: $font-size-md-large;\n    font-style: normal;\n    line-height: 120%;\n    padding-top: $spacing-xxs;\n  }\n\n  @include sm {\n    border-right: $spacing-zero;\n  }\n\n  .countryLogo {\n    border-radius: $radius-circle;\n  }\n}\n\n.headertop {\n  height: 80px;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  background: $color-header-primary-bg;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n\n  @include sm {\n    border-bottom: none;\n    height: 0;\n  }\n}\n\n.dttReports {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: $color-white;\n  cursor: pointer;\n  margin-left: $spacing-6xl;\n\n  .backArrow {\n    width: 24px;\n    height: 24px;\n  }\n\n  p {\n    width: 83px;\n    font-size: $font-size-md-large;\n    font-weight: $font-weight-normal;\n    line-height: 115%;\n    margin-bottom: $spacing-sm-s !important;\n  }\n\n  @include sm {\n    display: none;\n  }\n}\n\n.navlinks {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  color: $color-white;\n  margin-right: $spacing-4xl-m;\n  gap: $spacing-lg;\n  cursor: pointer;\n\n  .separator {\n    width: 1px;\n    height: $size-icon-lg;\n    background-color: $color-secondary-blue;\n    display: flex;\n    align-self: center;\n    flex-shrink: 0;\n  }\n\n  p {\n    font-size: $font-size-sm-base;\n    font-weight: $font-weight-normal;\n    margin-bottom: $spacing-zero;\n  }\n\n  span {\n    display: none;\n    gap: $spacing-sm-s;\n    align-items: center;\n    cursor: pointer;\n\n    p {\n      font-weight: $font-weight-normal;\n      font-size: $font-size-sm-base;\n    }\n  }\n\n  @include sm {\n    position: absolute;\n    left: -200%;\n  }\n}\n\n.profileIcon {\n  padding-left: $spacing-lg;\n  border-left: 1px solid $color-secondary-blue;\n\n  @include sm {\n    display: none !important;\n    border-left: 0;\n    padding-left: 0;\n  }\n\n  img {\n    width: $size-icon-lg;\n    height: $size-icon-lg;\n  }\n}\n\n:root {\n  --rt-opacity: 1 !important;\n}\n\n.popupModal {\n  background: $color-white !important;\n  border-radius: $radius-md;\n  padding: 0 !important;\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);\n  z-index: 1;\n  color: $color-black;\n  overflow: hidden;\n\n  .popup {\n    width: 344px;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    cursor: auto !important;\n\n    .popupDetails {\n      padding: $spacing-md;\n      width: 100%;\n      border-radius: 0;\n      background: $color-new-blue-pale;\n      display: flex;\n      flex-direction: row;\n      gap: $spacing-md;\n      align-items: center;\n\n      .popupProfileIcon {\n        flex-shrink: 0;\n        width: $spacing-4xl;\n        height: $spacing-4xl;\n        border-radius: $radius-circle;\n        background-color: $color-white;\n        padding: 12px;\n        box-sizing: border-box;\n        object-fit: contain;\n        object-position: center;\n      }\n\n      .profileText {\n        display: flex;\n        flex-direction: column;\n        gap: $spacing-xxs;\n        flex: 1;\n      }\n\n      h4 {\n        font-family: $font-family-desire-bold;\n        font-size: $font-size-md-medium;\n        margin: 0;\n        color: $color-black;\n        line-height: 120%;\n      }\n\n      p {\n        font-family: $font-family-desire-regular;\n        font-size: $font-size-sm-base;\n        margin: 0;\n        color: $color-black;\n        line-height: 120%;\n      }\n    }\n\n    .dtAccess {\n      display: grid;\n      grid-template-columns: 1fr auto;\n      row-gap: $spacing-xxs;\n      column-gap: $spacing-sm-s;\n      width: 100%;\n      padding: $spacing-xl $spacing-md 0;\n      color: $color-black;\n      align-items: start;\n      border-radius: 0;\n      background: $color-white;\n\n      p {\n        margin: 0;\n      }\n\n      .title {\n        font-family: $font-family-desire-semibold;\n        font-size: $font-size-md-medium;\n        color: $color-black;\n      }\n\n      .display {\n        font-family: $font-family-desire-regular;\n        font-size: $font-size-sm-base;\n        margin-left: 0;\n        grid-column: 1 / -1;\n        color: $color-black;\n      }\n\n      .toggle {\n        display: flex;\n        align-items: end;\n        color: $color-black;\n        cursor: pointer;\n      }\n    }\n\n    .popupLogout {\n      display: flex;\n      flex-direction: row;\n      gap: $spacing-sm-s;\n      padding: 16px;\n      margin: 0;\n      cursor: pointer;\n      width: fit-content;\n      border-radius: 0;\n      background: transparent;\n      justify-content: flex-start;\n      align-items: center;\n      transition: opacity 0.2s ease;\n\n      &:hover {\n        opacity: 0.8;\n      }\n\n      img {\n        display: none;\n      }\n\n      p {\n        color: $color-button-blue;\n        font-family: $font-family-desire-semibold;\n        font-size: $font-size-md-medium;\n        margin: 0;\n        padding: 0;\n      }\n    }\n  }\n\n  @include sm {\n    display: none;\n  }\n}\n\n.sideMenuOptions {\n  min-height: 64px;\n  display: none;\n\n  img {\n    width: 24px;\n    height: 24px;\n    color: $color-white;\n  }\n\n  p {\n    color: $color-white;\n    font-size: $font-size-sm-base;\n    font-style: normal;\n    font-weight: $font-weight-normal;\n    line-height: $line-height-medium;\n  }\n}\n\n\n.closebtn {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  right: $spacing-md-m;\n  top: $spacing-4xl;\n}\n\n.menuSide {\n  @extend .navlinks;\n\n  @include sm {\n    position: absolute;\n    left: 0;\n    bottom: $spacing-zero;\n    height: 100%;\n    width: 100%;\n    background-color: $color-white;\n    color: $color-black;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    z-index: 999;\n  }\n}\n\n.headerbottom {\n  width: 100%;\n  height: $spacing-5xl;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: linear-gradient(328deg, $color-bg-gradient-start 48.33%, $color-bg-gradient-end 101.85%);\n\n  p {\n    margin-bottom: $spacing-zero !important;\n    font-weight: $font-weight-normal;\n    font-size: $font-size-sm-base;\n    color: $color-white;\n  }\n\n  @include sm {\n    height: $spacing-6xl;\n\n    p {\n      margin-right: $spacing-md;\n      font-size: $font-size-md-medium;\n      margin-bottom: 0 !important;\n    }\n  }\n}\n\n.hideHeaderBottom {\n  display: none;\n}\n\n.headerSidebar {\n  @extend .headerbottom;\n\n  @include sm {\n    position: fixed;\n    background-color: $color-primary-blue;\n    display: flex;\n    flex-direction: column;\n    height: 250px;\n    width: 100%;\n    justify-content: space-around;\n    z-index: 999;\n\n    div,\n    p {\n      width: 100%;\n      display: flex;\n    }\n\n    p {\n      font-size: $font-size-md-medium;\n      bottom: $spacing-6xl;\n      left: $spacing-md;\n      width: auto;\n    }\n\n    .countryNameMbl {\n      display: none;\n    }\n  }\n}\n\n.menuIcons {\n  display: none;\n\n  @include sm {\n    display: block;\n  }\n}\n\n.menuSide {\n  @include sm {\n    border-radius: $spacing-xl $spacing-xl $spacing-zero $spacing-zero;\n    padding-top: $spacing-3xl;\n    position: fixed;\n    height: calc(100vh - 200px);\n    padding-left: $spacing-md;\n    overflow: hidden;\n    scrollbar-width: none;\n    background: $color-menu-bg;\n    z-index: 2000;\n\n    div,\n    span {\n      display: flex;\n      flex-direction: row;\n      gap: $spacing-md;\n      align-items: center;\n      text-align: center;\n      width: 100%;\n    }\n  }\n}\n\n.headerbottom {\n  .backButton {\n    p {\n      font-size: $font-size-md-medium;\n    }\n\n    @include sm {\n      display: none;\n    }\n  }\n}\n\n.dropdownConatiner {\n  display: flex;\n  gap: $spacing-md;\n  height: 100%;\n  padding: $spacing-zero $spacing-sm-s $spacing-zero $spacing-zero;\n  align-items: center;\n  margin-left: $spacing-6xl;\n\n  .backButton {\n    margin-left: 24px;\n  }\n\n  .dropdownWrapper {\n    display: flex;\n    height: 100%;\n  }\n\n  @include sm {\n    flex-direction: column !important;\n    display: none;\n  }\n\n  .dropdownselected {\n    background: $color-secondary-blue;\n    border-bottom: 3px solid $color-white;\n\n    span {\n      font-weight: $font-weight-semibold;\n    }\n  }\n\n  .dropdown {\n    position: relative;\n    height: 100%;\n    align-items: center;\n    display: flex;\n\n    @include sm {\n      flex-direction: column !important;\n    }\n\n    span {\n      color: $color-white;\n      font-size: $font-size-sm-base;\n      padding: $spacing-zero $spacing-sm-s;\n\n      @include sm {\n        color: $color-black;\n      }\n    }\n\n    .dropdownBody {\n      scrollbar-width: none;\n      position: absolute;\n      z-index: 1;\n      background: $color-primary-blue;\n      padding: 1rem $spacing-zero;\n      display: flex;\n      width: 322px;\n      flex-direction: column;\n      align-items: flex-start;\n      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n      top: 90%;\n      z-index: 9999;\n\n\n\n      .dropdownOptions:hover {\n        background-color: $color-secondary-blue;\n        font-weight: $font-weight-semibold;\n      }\n\n      .dropdownOptions {\n        font-size: $font-size-sm-base;\n        font-weight: $font-weight-normal;\n        color: $color-white;\n        width: 100%;\n        padding: $spacing-sm-s 1rem;\n      }\n    }\n  }\n}\n\n.SMOMobileView {\n  min-height: 64px;\n\n  p {\n    color: $color-white;\n\n  }\n}\n\n.dropdownMobile {\n  flex-direction: column !important;\n  gap: $spacing-zero !important;\n  height: max-content;\n  justify-content: flex-start;\n  font-size: $font-size-sm-base !important;\n  align-items: flex-start !important;\n  width: 100%;\n\n  .dropdownHeading {\n    margin-left: $spacing-zero;\n    min-height: 64px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n\n    .dropdownHeadingName {\n      flex-basis: 75%;\n    }\n\n    .dropdownHeadingArrow {\n      flex-basis: 25%;\n      justify-content: center;\n    }\n  }\n\n  .dropdownArrowOpen {\n    transform: rotate(-90deg);\n  }\n\n  .dropdownArrowClose {\n    transform: rotate(90deg);\n  }\n\n  span {\n    width: 100%;\n  }\n\n  .dropdownBody {\n    flex-direction: column !important;\n    gap: $spacing-zero !important;\n    overflow: hidden;\n    width: calc(100% + #{$spacing-md});\n    margin-left: -$spacing-md !important;\n\n    .dropdownOptions {\n      margin: $spacing-zero !important;\n      width: 100%;\n      padding-left: calc(2.5rem + 16px);\n      min-height: 48px;\n\n      div {\n        min-height: 48px;\n      }\n    }\n\n    .dropdownSelected {\n      background: $color-light-bg;\n    }\n  }\n}\n\n.navLinkSelected {\n  height: 100%;\n  padding: $spacing-zero $spacing-sm-s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-weight: $font-weight-semibold;\n  background-color: $color-secondary-blue !important;\n  position: relative;\n}\n\n.navLinkSelected::after {\n  content: \"\";\n  border: 3px solid $color-light-bg;\n  position: absolute;\n  bottom: -2px;\n  width: 102%;\n  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);\n}\n\n.adminDropdown {\n  position: relative;\n\n  img:last-child {\n    position: absolute;\n    right: $spacing-md;\n    transform: rotate(90deg);\n    transition: transform 0.1s ease-in-out;\n  }\n\n  .invertArrow {\n    transform: rotate(-90deg) !important;\n  }\n}\n\n.adminDropdownOptions {\n  display: flex;\n  flex-direction: column !important;\n  justify-content: center;\n  align-items: flex-start !important;\n  padding-left: 38px;\n\n  p {\n    height: 40px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n.dropdownCountry {\n  width: auto;\n  flex-shrink: 0;\n\n  @include sm {\n    width: auto;\n  }\n\n  .dropdownControl {\n    height: 100%;\n    min-height: 100%;\n    display: flex;\n    align-items: center;\n    padding: $spacing-zero;\n    background: transparent;\n    border: none !important;\n    border-color: transparent !important;\n    box-shadow: none !important;\n    outline: none !important;\n    width: fit-content;\n    cursor: pointer;\n\n    @include sm {\n      gap: 8px;\n    }\n\n    &:focus,\n    &:focus-visible,\n    &:focus-within {\n      border: none !important;\n      border-color: transparent !important;\n      box-shadow: none !important;\n      outline: none !important;\n    }\n\n    &:hover {\n      border: none;\n      box-shadow: none;\n      outline: none;\n    }\n\n    .countryName {\n      border-right: 0;\n      color: red;\n\n      .nameOption {\n        font-size: $font-size-md-xtraLarge;\n        font-weight: $font-weight-normal;\n        margin-bottom: 5px;\n      }\n\n      @include sm {\n        padding-right: 6px;\n      }\n    }\n\n    .dropdownArrow {\n      display: flex;\n      align-items: center;\n      margin-left: 4px;\n\n      div {\n        padding: 0;\n        display: flex;\n        align-items: center;\n        color: $color-white;\n      }\n\n      svg {\n        padding: 0 !important;\n      }\n    }\n\n    .dropdownArrowsm {\n      padding: 0 !important;\n      margin: 0 !important;\n\n      div {\n        padding: 0 !important;\n        margin: 0 !important;\n      }\n\n      svg {\n        display: none;\n      }\n\n      &::after {\n        content: \"\";\n        display: block;\n        width: $spacing-sm-s;\n        height: 6px;\n        background-image: url(\"../../../assets/images/CountrySelectMobileIcon.svg\");\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: contain;\n        margin: 0;\n      }\n    }\n\n    .dropdownText {\n      width: max-content;\n      font-size: 90%;\n      font-weight: $font-weight-normal;\n      color: $color-white;\n      font-family: $font-family-base, -apple-system,\n        BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n        \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\" !important;\n    }\n  }\n\n  .seperator {\n    display: none;\n  }\n\n  .dropdownArrow {\n    display: flex;\n    align-items: center;\n\n    div {\n      display: flex;\n      align-items: center;\n      padding: 0;\n      color: $color-white;\n    }\n\n    svg {\n      display: block;\n    }\n  }\n\n  .menu {\n    width: $size-dropdown-country-width;\n    height: $size-dropdown-country-height;\n    overflow: hidden;\n    background: $color-white;\n\n    @include sm {\n      position: absolute;\n      right: 15%;\n    }\n  }\n\n  .menuList {\n    padding: 0;\n    border-radius: $radius-dropdown-country;\n    background: $color-white;\n  }\n\n  .menuOption {\n    min-width: 100%;\n    width: fit-content;\n    cursor: pointer;\n    border-bottom: none;\n    background: $color-white;\n\n    &:first-child {\n      background: $color-new-blue-pale;\n    }\n\n    .countryName {\n      border-right: 0;\n\n      .nameOption {\n        font-size: $font-size-md-medium;\n        font-weight: $font-weight-light;\n        color: $color-black;\n        padding-bottom: $spacing-sm-l;\n      }\n    }\n\n    &:hover {\n      background: $color-new-blue-pale;\n    }\n\n    .selected {\n      background: $color-new-blue-pale;\n    }\n  }\n}\n\n.flexibleRow {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: $spacing-md;\n\n  .separator {\n    width: 1px;\n    height: $size-icon-lg;\n    background-color: $color-secondary-blue;\n    margin: 0 $spacing-sm-s;\n    display: flex;\n    align-self: center;\n  }\n}\n\n.mobileCenterLogo {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 143px;\n  height: 49px;\n  cursor: pointer;\n}\n\n.flexibleCol {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: $spacing-md $spacing-md $spacing-3xl $spacing-md;\n  border-radius: $radius-md;\n  background: linear-gradient(328deg, $color-panel-bg 48.33%, $color-card-content 101.85%);\n  color: $color-white;\n\n  h4 {\n    padding: $spacing-xl 0 15px;\n    margin: 0;\n    font-family: $font-family-base;\n    font-weight: $font-weight-black;\n    font-style: normal;\n    font-size: $font-size-md-medium;\n    line-height: 120%;\n    letter-spacing: 0%;\n  }\n\n  >p {\n    margin: 0 0 15px 0 !important;\n    font-family: $font-family-base;\n    font-style: normal;\n    font-size: $font-size-sm-small;\n    line-height: 120%;\n    color: $color-white;\n  }\n\n  >p:nth-of-type(1) {\n    font-weight: $font-weight-normal;\n  }\n\n  >p:nth-of-type(2) {\n    font-weight: $font-weight-semibold;\n  }\n\n  .bsaRow {\n    margin-top: 0;\n  }\n}\n\n.bsaRow {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: $spacing-sm-s;\n  width: 100%;\n  flex-wrap: nowrap;\n\n  span {\n    white-space: nowrap;\n    font-family: $font-family-base;\n    font-style: normal;\n    font-weight: $font-weight-semibold;\n    font-size: $font-size-sm-small;\n    line-height: 120%;\n    color: $color-white;\n  }\n}\n\n.bsaSelectContainer {\n  width: auto;\n  min-width: 110px;\n  display: inline-block;\n}\n\n.bsaSelectControl {\n  min-height: $spacing-lg !important;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  cursor: pointer;\n  flex-wrap: nowrap !important;\n}\n\n.bsaSelectValue {\n  padding: 0 !important;\n  overflow: visible !important;\n  flex-wrap: nowrap !important;\n}\n\n.bsaSelectText {\n  position: static !important;\n  transform: none !important;\n  max-width: none !important;\n  font-family: $font-family-base !important;\n  font-style: normal !important;\n  font-weight: $font-weight-normal !important;\n  font-size: $font-size-sm-small !important;\n  line-height: 120% !important;\n  color: $color-white !important;\n  margin: 0 !important;\n  white-space: nowrap !important;\n  overflow: visible !important;\n}\n\n.bsaSelectInput {\n  color: transparent !important;\n  caret-color: transparent !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  width: 0 !important;\n\n  input {\n    caret-color: transparent !important;\n    color: transparent !important;\n    width: 0 !important;\n    opacity: 0 !important;\n  }\n}\n\n.bsaSelectIndicators {\n  padding: 0 !important;\n  align-items: center !important;\n}\n\n.bsaSelectArrow {\n  padding: 0 0 0 $spacing-xxs !important;\n  color: $color-white !important;\n\n  svg {\n    width: $spacing-sm-m;\n    height: $spacing-sm-m;\n    fill: $color-white;\n  }\n\n  &:hover {\n    color: $color-white !important;\n  }\n}\n\n.bsaSelectMenu {\n  width: 113px !important;\n  background: $color-menu-bg !important;\n  border: 1px solid $color-border-blue !important;\n  border-radius: $radius-sm !important;\n  margin: $spacing-xxs 0 0 0 !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;\n  overflow: hidden;\n}\n\n.bsaSelectMenuList {\n  padding: 0 !important;\n  background: $color-menu-bg !important;\n  display: flex !important;\n  flex-direction: column !important;\n  width: 100% !important;\n}\n\n.bsaSelectOption {\n  display: block !important;\n  width: 100% !important;\n  box-sizing: border-box !important;\n  font-family: $font-family-base !important;\n  font-style: normal !important;\n  font-weight: $font-weight-normal !important;\n  font-size: $font-size-sm-small !important;\n  line-height: 120% !important;\n  color: $color-white !important;\n  background: $color-menu-bg !important;\n  padding: $spacing-sm-s $spacing-xs !important;\n  cursor: pointer !important;\n\n  &:hover,\n  &:active {\n    background: $color-menu-hover !important;\n  }\n\n  &[aria-selected=\"true\"] {\n    background: $color-menu-hover !important;\n    font-weight: $font-weight-semibold !important;\n  }\n}\n\n.adminConfigSpan {\n  color: $color-white;\n  font-size: $font-size-sm-base;\n  font-weight: $font-weight-medium;\n  margin-left: $spacing-lg;\n  cursor: pointer;\n}\n\n.adminBreadcrumb {\n  display: flex;\n  align-items: center;\n  gap: $spacing-xs;\n}\n\n.adminBreadcrumbSeparator,\n.adminBreadcrumbCurrent {\n  color: $color-white;\n  font-size: $font-size-sm-base;\n  font-weight: $font-weight-medium;\n}\n\n.adminBreadcrumbSeparator {\n  opacity: 0.7;\n}","// Color codes here.\n$headerBlue:#275CE6;\n$headerBorder:#5588F7;\n$primaryBlue:#275CE6;\n$secondryBlue:#5588F7;\n$white:#FFFFFF;\n$tertiaryGrey:#676E72;\n$errorRed: #D52F3D;\n$progressRed:#E43263;\n$errorRed: #D52F3D;\n$progressGreen:#59B876;\n$progressCircleGrey:#9496A0;\n$black:#000000;\n$timedetailsGrey:#F3F7FD;\n$buttonbgBlue:#5588F7;\n$inputBorder:#CCCFD0;\n$buttonDisableBg:#E5E6E7;\n$buttonDisableText:#999EA1;\n$errorMessageRed:#FF5C83;\n$darkGreyText:#333C43;\n$tableHeader:#F6FCFF;\n$LandingPageBlue:#1E49B9;\n$secondary_lightish:#E1ECF5;\n$opTabViewDisabled:#F2F3F3;\n$otpGreyText:#B3B6C5;\n$otpErrorRed:#D52F3D;\n$oddTableRow: #f8f9fc;\n$agTableRow: #f3f3f3;\n$scrollbar: #888;\n$scrollbarHover: #555;\n$scrollbarTrack: #f1f1f1;\n$dropdownListColor: #f0f0f0;\n$dropdownShadow: #6123E70F;\n$disableButton : #cccccc;\n$progressContainer: #e0e0e0;\n$toggleSwitchOff: #00000066;\n$toggleSwitchOn: #03A742;\n// Font Sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-xl-large: 32px;\n$font-size-xl-xtraLarge: 40px;\n$font-size-xl-medium: 28px;\n\n// Font weights\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n// Font Styles\n$font-style: 'Unilever Shilling';\n$font-family-desire-light: 'Unilever Desire Light', sans-serif;\n\n// Line Height\n$line-height-medium: 16px;\n\n// Spacing\n$spacing-zero: 0px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-md: 16px;\n$spacing-md-m: 18px;\n","// Existing scale (preserved)\n$spacing-zero: 0px;\n$spacing-neg-xxxs: -3px;\n$spacing-xxxs: 2px;\n$spacing-xxxs-m: 3px;\n$spacing-xs-m: 5px;\n$spacing-xxs-m: 6px;\n$spacing-xs: 10px;\n$spacing-sm: 12px;\n$spacing-sm-m: 14px;\n$spacing-sm-l: 15px;\n$spacing-md: 16px;\n$spacing-md-s: 13px;\n$spacing-md-m: 18px;\n\n// New additions for landing components\n$spacing-xxs: 4px;\n$spacing-sm-s: 8px;\n$spacing-lg: 20px;\n$spacing-xl: 24px;\n$spacing-xl-s: 25px;\n$spacing-xl-m: 28px;\n$spacing-2xl: 30px;\n$spacing-3xl: 32px;\n$spacing-3xl-m: 36px;\n$spacing-4xl: 40px;\n$spacing-4xl-m: 48px;\n$spacing-5xl-s: 50px;\n$spacing-5xl: 56px;\n$spacing-6xl: 60px;\n$spacing-16xl: 160px;\n$spacing-page-content-x: 140px;\n$spacing-page-x: 54px;\n","//legend color boxes\n$color-perfectstore-orange: #FF9A00;\n$color-perfectstore-green: #52D273;\n$color-perfectstore-bar-bg: rgba(1, 45, 87, 1);\n$color-perfectstore-bar-gradient: linear-gradient(135deg,#1b5fa7,#0e4c8f);\n// --- Base ---\n$color-white: #FFFFFF;\n$color-black: #000000;\n\n// --- Brand Blues (Landing cards & panels) ---\n$color-card-bg-dark: #00000033;\n$color-card-bg-medium: #0D4F8E;\n$color-card-content: #0066CC;\n$color-card-image-bg: #005AB3;\n$color-panel-bg: #19326833;\n\n$color-card-bg-active: #042E55;\n$color-card-bg-hover: #1a3d7a;\n\n// --- Text on dark backgrounds ---\n$color-text-white-muted: rgba(255, 255, 255, 0.7);\n$color-overlay-white-70: rgba(255, 255, 255, 0.7);\n\n// --- Header & Navigation ---\n$color-header-bg: #01010129; \n$color-header-secondary-bg: #00000014; \n$color-header-primary-bg: #005AB4;\n$color-primary-blue: #275CE6;\n$color-secondary-blue: #5588F7;\n$color-border-blue: #2381DE;\n\n// --- Menu ---\n$color-menu-bg: #082D54;\n$color-menu-hover: #054179;\n\n// --- Neutral / UI ---\n$color-light-bg: #F3F7FD;\n\n// --- Notification ---\n$color-notification-bg: rgba(251, 245, 206, 0.95);\n$color-notification-border: #d2bf47;\n\n// --- Background Gradient ---\n$color-bg-gradient-start: #006FDE;\n$color-bg-gradient-end: #06C;\n$color-bg-gradient-card-blue: linear-gradient(0deg, #0D4F8E 0%, #0D4F8E 100%), #06C;\n$color-bg-gradient-secondary-start: #026CCE;\n$color-bg-gradient-secondary-end: #013768;\n\n// --- Blur Effects ---\n$color-blur-purple: rgba(120, 50, 180, 0.5);\n\n// --- Borders ---\n$color-border-white-translucent: rgba(255, 255, 255, 0.3);\n$color-border-light-blue: #C2E0FF;\n$color-new-blue-pale: #C2E0FF;\n\n// --- Buttons ---\n$color-button-blue: #0066CC;\n$color-login-primary-blue: #1E49B9;\n\n// --- Text ---\n$color-text-dark-grey: #333C43;\n\n// --- KPI / Status ---\n$color-kpi-green: #59B876;\n$color-kpi-red: #E43263;\n$color-kpi-error: #D52F3D;\n$color-text-light: #F2F3F3;\n$color-border-light: #f2f3f3;\n\n// --- KPI / Surfaces ---\n$color-kpi-header-bg: #1464B1;\n$color-kpi-body-bg: #044888;\n$color-kpi-badge-bg: #002B55;\n$color-kpi-switch-bg: #0F569B;\n$color-kpi-switch-active-bg: #004C99;\n$color-kpi-switch-selected-bg: #B9D8F8;\n$color-kpi-switch-selected-text: #0C3F70;\n$color-kpi-icon-bg: #DCEAFF;\n\n// --- Overlays / Borders ---\n$color-overlay-white-06: rgba(255, 255, 255, 0.06);\n$color-overlay-white-08: rgba(255, 255, 255, 0.08);\n$color-overlay-white-10: rgba(255, 255, 255, 0.1);\n$color-overlay-white-12: rgba(255, 255, 255, 0.12);\n$color-overlay-white-15: rgba(255, 255, 255, 0.15);\n$color-overlay-white-16: rgba(255, 255, 255, 0.16);\n$color-overlay-white-18: rgba(255, 255, 255, 0.18);\n$color-overlay-white-20: rgba(255, 255, 255, 0.2);\n$color-overlay-white-22: rgba(255, 255, 255, 0.22);\n$color-overlay-white-30: rgba(255, 255, 255, 0.3);\n$color-overlay-black-04: rgba(0, 0, 0, 0.04);\n$color-overlay-black-08: rgba(0, 0, 0, 0.08);\n$color-overlay-black-10: rgba(0, 0, 0, 0.1);\n$color-overlay-black-15: rgba(0, 0, 0, 0.15);\n$color-overlay-black-20: rgba(0, 0, 0, 0.2);\n$color-overlay-black-24: #0000003D;\n$color-overlay-black-30: rgba(0, 0, 0, 0.3);\n$color-overlay-black-38: rgba(0, 0, 0, 0.38);\n$color-overlay-modal-20: rgba(3, 13, 20, 0.2);\n$color-overlay-modal-12: rgba(3, 13, 20, 0.12);\n$color-overlay-panel-80: rgba(19, 48, 98, 0.8);\n$color-tab-active-overlay: rgba(15, 86, 155, 0.53);\n$color-border-neutral-10: #E5E6E7;\n$color-text-ivory: #F6F7F0;\n$color-border-white-soft: rgba(247, 247, 247, 0.32);\n$color-kpi-orange: #F5A623;\n$color-text-dark-primary: #111111;\n$color-kpi-card-top-bg: #1165B8;\n$color-progress-fill-blue: #8ADAFF;\n\n// --- Text / Neutral additions ---\n$color-text-muted-blue: #B8C7E0;\n$color-text-muted-blue-light: #DFE6F3;\n$color-text-slate-700: #1F2937;\n$color-text-disabled: #CCCCCC;\n$color-input-border: #CCCFD0;\n$color-text-neutral-40: #9496A0;\n$color-text-ic-01: #FFF0EF;\n$color-primary-darkest: #090041;\n\n// --- UI surface additions ---\n$color-overlay-white-04: rgba(255, 255, 255, 0.04);\n$color-overlay-white-10: rgba(255, 255, 255, 0.1);\n$color-overlay-white-52: rgba(255, 255, 255, 0.52);\n$color-overlay-white-55: rgba(255, 255, 255, 0.55);\n$color-overlay-white-72: rgba(255, 255, 255, 0.72);\n$color-border-soft-blue: #D5DBE5;\n$color-surface-hover-blue-soft: #EAF4FF;\n$color-border-muted-blue: #A7B2C2;\n$color-panel-blue: #265B9C;\n$color-overlay-black-80: rgba(0, 0, 0, 0.8);\n$color-error-border-pink: #FF5C83;\n\n// --- Grid additions ---\n$color-grid-header-overlay: rgba(19, 80, 153, 0.6);\n$color-grid-row-overlay: rgba(34, 88, 166, 0.45);\n$color-grid-border-cyan: #3BADEB;\n$color-grid-scroll-track: #133A76;\n$color-grid-scroll-thumb: #D9D9D9;\n$color-grid-scroll-thumb-hover: #BFBFBF;\n\n// --- KPI card additions ---\n$color-kpi-card-top-overlay: #0000002E;\n$color-kpi-card-bottom-overlay: #0000001A;\n$color-kpi-card-split-overlay: #082D5480;\n$color-kpi-card-summary-top: #0066CC33;\n$color-kpi-card-summary-body: #082D5433;\n$color-kpi-card-summary-cell: #044E9833;\n$color-kpi-positive-dot: #00D492;\n$color-kpi-negative-dot: #FF9AAB;\n\n// --- Status dot additions ---\n$color-status-dot-green: #03A742;\n$color-status-dot-red: #CA6580;\n\n// --- PS Filter Modal ---\n$color-filter-modal-overlay: rgba(0, 0, 0, 0.55);\n$color-filter-text-dark: #1a1a1a;\n$color-filter-border-inactive: #adb5c7;\n$color-filter-checkbox-active: #1565c0;\n$color-filter-checkbox-active-hover: #0d47a1;\n$color-filter-btn-disabled-bg: #d0d5df;\n$color-filter-btn-disabled-text: #8a8fa3;\n$color-filter-modal-shadow: rgba(0, 0, 0, 0.18);\n// --- SmTracking ---\n$color-smtracking-filter-badge: #D92D53;\n$color-new-blue-pale-50: rgba(194, 224, 255, 0.5);\n","$font-family-base: 'Unilever Desire', sans-serif;\n$font-family-desire-regular: 'Unilever Desire Regular', sans-serif;\n$font-family-desire-semibold: 'Unilever Desire Semi Bold', sans-serif;\n$font-family-desire-bold: 'Unilever Desire Bold', sans-serif;\n$font-family-desire-regular-italic: 'Unilever Desire Regular Italic', sans-serif;\n$font-family-desire-light: 'Unilever Desire Light', sans-serif;\n\n// Font sizes\n$font-size-xs-small: 10px;\n$font-size-sm-small: 12px;\n$font-size-sm-caption: 13px;\n$font-size-sm-base: 14px;\n$font-size-md-medium: 16px;\n$font-size-md-large: 18px;\n$font-size-md-xtraLarge: 20px;\n$font-size-md-xLarge: 22px;\n$font-size-lg-medium: 24px;\n$font-size-lg-large: 28px;\n$font-size-lg-xxlarge: 30px;\n$font-size-lg-xtraLarge: 32px;\n$font-size-xl-display: 42px;\n\n// Line heights\n$line-height-sm: 20px;\n$line-height-md: 24px;\n$line-height-lg: 32px;\n\n// Font weights\n$font-weight-light: 200;\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n$font-weight-black: 900;\n","\n$radius-xs: 1px;\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-dropdown-country: 9px 8px 0 0;\n$radius-xl: 16px;\n$radius-lg: 24px;\n$radius-full: 40px;\n$radius-pill: 50px;\n$radius-circle: 50%;\n","//width \n\n$size-perfectstore-width: 1332px;\n$size-perfectstore-card-width: 432px;\n$size-perfectstore-card-height: 155px;\n$size-store-icon: 14px;\n$size-colored-box-width: 18px;\n$size-colored-box-height: 16px;\n$size-icon-xxs: 11px;\n$size-blur-lg: 400px;\n$size-blur-sm: 250px;\n\n// Icon sizes\n$size-icon-xs: 16px;\n$size-icon-sm: 20px;\n$size-icon-md: 24px;\n$size-icon-lg: 37px;\n\n// Dropdown sizes\n$size-dropdown-country-width: 219px;\n$size-dropdown-country-height: 229px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainHeader": `LandingHeader_mainHeader__TldZM`,
	"mainHeaderSpacer": `LandingHeader_mainHeaderSpacer__n43st`,
	"header": `LandingHeader_header__vO4uP`,
	"countryName": `LandingHeader_countryName__to+Eu`,
	"name": `LandingHeader_name__DnQ6D`,
	"countryLogo": `LandingHeader_countryLogo__z-YKm`,
	"headertop": `LandingHeader_headertop__AiSkM`,
	"dttReports": `LandingHeader_dttReports__c+wQx`,
	"backArrow": `LandingHeader_backArrow__OPsl8`,
	"navlinks": `LandingHeader_navlinks__Ojrcm`,
	"menuSide": `LandingHeader_menuSide__pMvr+`,
	"separator": `LandingHeader_separator__Zf91h`,
	"profileIcon": `LandingHeader_profileIcon__40li3`,
	"popupModal": `LandingHeader_popupModal__Da4gL`,
	"popup": `LandingHeader_popup__s7p+C`,
	"popupDetails": `LandingHeader_popupDetails__DE8ju`,
	"popupProfileIcon": `LandingHeader_popupProfileIcon__P1huv`,
	"profileText": `LandingHeader_profileText__9TF1Z`,
	"dtAccess": `LandingHeader_dtAccess__Iqlx8`,
	"title": `LandingHeader_title__ANkLM`,
	"display": `LandingHeader_display__ZmToR`,
	"toggle": `LandingHeader_toggle__evyER`,
	"popupLogout": `LandingHeader_popupLogout__MKqR4`,
	"sideMenuOptions": `LandingHeader_sideMenuOptions__oz4T8`,
	"closebtn": `LandingHeader_closebtn__-LIU7`,
	"headerbottom": `LandingHeader_headerbottom__Ci5x2`,
	"headerSidebar": `LandingHeader_headerSidebar__N2hsW`,
	"hideHeaderBottom": `LandingHeader_hideHeaderBottom__FWKrB`,
	"countryNameMbl": `LandingHeader_countryNameMbl__aVA-+`,
	"menuIcons": `LandingHeader_menuIcons__9219c`,
	"backButton": `LandingHeader_backButton__gNFPL`,
	"dropdownConatiner": `LandingHeader_dropdownConatiner__e1IUB`,
	"dropdownWrapper": `LandingHeader_dropdownWrapper__FMqxa`,
	"dropdownselected": `LandingHeader_dropdownselected__2DCJP`,
	"dropdown": `LandingHeader_dropdown__+LP1J`,
	"dropdownBody": `LandingHeader_dropdownBody__lTzKl`,
	"dropdownOptions": `LandingHeader_dropdownOptions__-1IG4`,
	"SMOMobileView": `LandingHeader_SMOMobileView__JVXod`,
	"dropdownMobile": `LandingHeader_dropdownMobile__HZcXX`,
	"dropdownHeading": `LandingHeader_dropdownHeading__22sG3`,
	"dropdownHeadingName": `LandingHeader_dropdownHeadingName__A+o+4`,
	"dropdownHeadingArrow": `LandingHeader_dropdownHeadingArrow__rpRTY`,
	"dropdownArrowOpen": `LandingHeader_dropdownArrowOpen__TsJiP`,
	"dropdownArrowClose": `LandingHeader_dropdownArrowClose__JnMst`,
	"dropdownSelected": `LandingHeader_dropdownSelected__8lco7`,
	"navLinkSelected": `LandingHeader_navLinkSelected__Rb698`,
	"adminDropdown": `LandingHeader_adminDropdown__novhE`,
	"invertArrow": `LandingHeader_invertArrow__Vl77p`,
	"adminDropdownOptions": `LandingHeader_adminDropdownOptions__lu60z`,
	"dropdownCountry": `LandingHeader_dropdownCountry__6R8oG`,
	"dropdownControl": `LandingHeader_dropdownControl__rn5px`,
	"nameOption": `LandingHeader_nameOption__r5kmz`,
	"dropdownArrow": `LandingHeader_dropdownArrow__yQGyO`,
	"dropdownArrowsm": `LandingHeader_dropdownArrowsm__c38De`,
	"dropdownText": `LandingHeader_dropdownText__gj-mB`,
	"seperator": `LandingHeader_seperator__7ES4p`,
	"menu": `LandingHeader_menu__tdNHP`,
	"menuList": `LandingHeader_menuList__OlmUw`,
	"menuOption": `LandingHeader_menuOption__1bsrG`,
	"selected": `LandingHeader_selected__gasba`,
	"flexibleRow": `LandingHeader_flexibleRow__m-9Z3`,
	"mobileCenterLogo": `LandingHeader_mobileCenterLogo__d2DFP`,
	"flexibleCol": `LandingHeader_flexibleCol__47UpL`,
	"bsaRow": `LandingHeader_bsaRow__y2P0H`,
	"bsaSelectContainer": `LandingHeader_bsaSelectContainer__ohUa7`,
	"bsaSelectControl": `LandingHeader_bsaSelectControl__go3CE`,
	"bsaSelectValue": `LandingHeader_bsaSelectValue__XDAFB`,
	"bsaSelectText": `LandingHeader_bsaSelectText__1l6Er`,
	"bsaSelectInput": `LandingHeader_bsaSelectInput__edCzJ`,
	"bsaSelectIndicators": `LandingHeader_bsaSelectIndicators__jnYZP`,
	"bsaSelectArrow": `LandingHeader_bsaSelectArrow__su8rL`,
	"bsaSelectMenu": `LandingHeader_bsaSelectMenu__Yaw9J`,
	"bsaSelectMenuList": `LandingHeader_bsaSelectMenuList__L8B3d`,
	"bsaSelectOption": `LandingHeader_bsaSelectOption__KMwzx`,
	"adminConfigSpan": `LandingHeader_adminConfigSpan__CPbCO`,
	"adminBreadcrumb": `LandingHeader_adminBreadcrumb__Rj-KE`,
	"adminBreadcrumbSeparator": `LandingHeader_adminBreadcrumbSeparator__QlgUv`,
	"adminBreadcrumbCurrent": `LandingHeader_adminBreadcrumbCurrent__rStY0`
};
export default ___CSS_LOADER_EXPORT___;
